import React, {useState} from 'react';
import Typography from "@mui/material/Typography";
import {ThumbDown, ThumbUp, ThumbDownOutlined, ThumbUpOutlined} from "@mui/icons-material";
import {Flex} from "reflexbox";
import Button from "@mui/material/Button";
import CardContainer from "../components/courseContentDisplays/CardContainer";
import {useNavigate} from "react-router-dom";
import * as route from "../components/helpers/routes";
import {nativeApi} from '../components/expo/NativeAPI';
import ReactGA from 'react-ga';
import {isProd} from "../components/helpers/misc";
import PageHeader from "../components/gamePlayComponents/PageHeader";
import {usePlatformInsets} from "../components/helpers/usePlatformInsets";
import {APP_STORE_URL, PLAY_STORE_URL} from "./Feedback";

const APP_STORE_WRITE_REVIEW_URL = `${APP_STORE_URL}?action=write-review`;

const RateUs = (props) => {
  let navigate = useNavigate();
  const viewingIndividualPage = window.location.pathname === route.RATEUS;
  const {isNative, platform} = usePlatformInsets();

  const [selected, setSelected] = useState(0);

  const handleThumbUp = () => {
    setSelected(1);
    nativeApi.requestAppReview();
  };

  const handleOpenStoreReview = () => {
    const url = platform === 'ios' ? APP_STORE_WRITE_REVIEW_URL : PLAY_STORE_URL;
    nativeApi.openExternalLink(url);
  };

  const storeReviewLabel =
    platform === 'ios'
      ? 'Leave a review on the App Store'
      : 'Leave a review on Google Play';


  const handleSubmit= ()=> {
    let rating;
    if (selected === 1){
      rating = "Thumbs up"
    } else if (selected === 2) {
      rating = "Thumbs down"
    } else {
      rating = "Skipped"
    }
    //send GA event
    isProd && ReactGA.event({
      category: 'Rating',
      action: rating
    });
    //go to next URL
    if (viewingIndividualPage){
      navigate(-1)
    } else {
      navigate(props.nextURL)
    }
  };

  const cardContent1 = (<>
    <Flex style={{flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
      <Typography variant={'h6'} color={'primary'}> Enjoying the game? </Typography>
      <Flex style={{margin: '16px'}}>

        {selected === 1 ? <ThumbUp color={'primary'} fontSize={'large'} onClick={()=> setSelected(0)} />
        : <ThumbUpOutlined color={'primary'} fontSize={'large'} onClick={handleThumbUp}/>}
        <div style={{width: '20px'}}/>
        <div style={{top: '11px', position: 'relative'}}>
          {selected === 2 ? <ThumbDown color={'primary'} fontSize={'large'} onClick={()=> setSelected(0)} />
          : <ThumbDownOutlined color={'primary'} fontSize={'large'} onClick={()=> setSelected(2)}/>}
        </div>
      </Flex>
      <Typography variant="caption" sx={{ color: selected === 0 ? 'transparent' : 'text.secondary' }}>
        Thanks for the feedback!
      </Typography>
      {isNative && (platform === 'ios' || platform === 'android') && (
        <Button
          variant="outlined"
          color="primary"
          onClick={handleOpenStoreReview}
          sx={{mt: 2}}
        >
          {storeReviewLabel}
        </Button>
      )}
    </Flex>
  </>);

  const actionComponent = (<Flex style={{justifyContent: 'center'}}>
    <Button variant={'contained'} color={'primary'} onClick={handleSubmit}
            style={{minWidth: '105px'}}>{viewingIndividualPage ? 'Back' : selected > 0 ? 'Continue' : 'Skip'}</Button>
  </Flex>);

  return(<>
    {viewingIndividualPage && <PageHeader title={''} goBack/>}
    <CardContainer
      alternateHeader
      subheader={null}
      cardContent1={cardContent1}
      actionsComponent={actionComponent}/>
  </>)
};

export default RateUs;